import NavBar from "../../Components/NavBar"
import { useState } from "react";
import ShowClose from "../../Components/showClose";
import SEO from "../../Components/SEO";
const FAQ = () => {

  const faqsFormatted = [
    {
        id: 1,
        title: "What services does Imash Insure offer?",
        content: [
            "We specialize in insurance outsourcing services including New Business Application Processing, Policy Issuance & Administration, Underwriting Support, Claims Management and Customer Support."
        ]
    },
    {
        id: 2,
        title: "Who can benefit from your services?",
        content: [
            "Our services are ideal for insurance agencies, MGAs, brokers and carriers looking to scale operations, reduce overhead and improve turnaround times especially startups and growing firms."
        ]
    },
    {
        id: 3,
        title: "How secure is my data with Imash Insure?",
        content: [
            "We use HIPAA/GDPR-compliant encryption and take data privacy seriously.",
            "All client information is handled with strict confidentiality and protected using industry-standard security protocols, including encrypted data handling and secure storage."
        ]
    },
    {
        id: 4,
        title: "How does onboarding work?",
        content: [
            "Once you contact us, we’ll schedule a discovery call to understand your business needs.",
            "From there, we’ll propose a customized solution and assist you through a seamless onboarding process."
        ]
    },
    {
        id: 5,
        title: "What regions or markets do you serve?",
        content: [
            "We serve clients across the USA markets.",
            "Our remote teams are equipped to support businesses across time zones."
        ]
    },
    {
        id: 6,
        title: "Do you provide support outside of business hours?",
        content: [
            "We provide flexible support options, including after-hours and round-the-clock 24/7 assistance, tailored to your service level agreement (SLA)."
        ]
    },
    {
        id: 7,
        title: "How do I contact customer support?",
        content: [
            "Call us anytime at:",
            "+1 765-888-2158",
            "+1 765-888-2149 (24/7)",
            "Email: shan@imashinsure.com"
        ]
    },
    {
        id: 8,
        title: "How can I get started with Imash Insure?",
        content: [
            "Getting started is simple! Reach out to us via our website or email shan@imashinsure.com and our team will guide you through every step."
        ]
    }
];


    const [show, setOpenIndex] = useState(null);

    const handleToggle = (index) => {
        setOpenIndex(show === index ? null : index);
    };
    return (
        <>
        <SEO
                title="Insurance Outsourcing FAQs | Back Office Support USA"
                description="Get answers to common questions about insurance outsourcing, back-office support, virtual assistants, security, compliance, and pricing for U.S. agencies"
            />
            <NavBar
                title={"FAQ"}
                image={"/images/FAQ-image.jpg"}
                description={`Imash Insurance is your trusted partner in protection.
We offer tailored insurance solutions for individuals and businesses.
Our mission is to provide security, simplicity and peace of mind.
With expert guidance and reliable service, we’re always here for you.
Protect what matters most choose Imash, choose confidence.`}
            />

            <ShowClose content={faqsFormatted} show={show} handleToggle={handleToggle} />

        </>
    )
}
export default FAQ